import useIsDesktop from "@hooks/useIsDesktop"

import styles from "./ViewBarVerticalDivider.module.scss"

export default function ViewBarVerticalDivider() {
    const isDesktop = useIsDesktop()

    if (isDesktop) {
        return <div className={styles.base}>/</div>
    } else {
        return null
    }
}
